
import Vue, {
  reactive, ref, watch
} from 'vue';
import BCXValidatedInput from '@/components/molecules/BCXValidatedInput.vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import { useRouter } from 'vue2-helpers/vue-router';
import useVuelidate from '@vuelidate/core';
import useBCValidators from '@/mixins/useBCValidators';
import ButtonBlock from '@/components/login-register/ButtonBlock.vue';
import { logError } from '@/utils/logger';
import PasswordResetService from '@/services/PasswordResetService';
import { useSessionStorage } from '@vueuse/core';

export default Vue.extend({
  name: 'PasswordReset',
  components: { ButtonBlock, BCXMarkdown, BCXValidatedInput },
  setup() {
    const router = useRouter();
    const resetEmail = useSessionStorage('passwordResetEmail', '');
    const invalidEmail = ref(false);

    const fields = reactive({
      email: ''
    });

    const { emailValidation } = useBCValidators();

    const rules = {
      email: emailValidation
    };

    const v = useVuelidate(rules, fields);

    watch(() => fields.email, () => {
      invalidEmail.value = false;
    });

    const resetPassword = async () => {
      invalidEmail.value = false;
      if (await v.value.$validate()) {
        PasswordResetService.resetPassword(fields.email)
          .then(() => {
            resetEmail.value = fields.email;
            router.push({ name: 'password-reset-confirmation' });
          }).catch((error) => {
            logError('There was an error!', error);
            if (error.response?.status !== 200) {
              invalidEmail.value = true;
            }
          });
      }
    };

    return {
      fields,
      v,
      invalidEmail,
      resetPassword,
      goBack: () => router.back()
    };
  },
});
